import axios from 'axios'; // POST
import cachios from 'cachios'; // GET
// import querystring from 'querystring';
// import * as sgMail from '@sendgrid/mail';

class Api {
  baseUrl = "https://frosty-storm-gvmt9bvmf3r8.vapor-farm-a1.com/api/v1";

  getHome = async () => {
    return await cachios.get(this.baseUrl + `/home`);
  }

  getAbout = async () => {
    return await cachios.get(this.baseUrl + `/about-us`);
  }

  getblog = async () => {
    return await cachios.get(this.baseUrl + `/blogs`);
  }

  getblogSinglePage = async (id) => {
    return await cachios.get(this.baseUrl + `/blogs/` + id);
  }

  getTerms = async () => {
    return await cachios.get(this.baseUrl + `/terms-conditions`);
  }

  getFaq = async () => {
    return await cachios.get(this.baseUrl + `/faq`);
  }

  getPolicy = async () => {
    return await cachios.get(this.baseUrl + `/privacy-policy`);
  }

  getFilterData = async () => {
    return await cachios.get(this.baseUrl + `/sizes-effects`);
  }

  getCollection = async () => {
    return await cachios.get(this.baseUrl + `/collections`);
  }

  getCollectionSinglePage = async (id) => {
    return await cachios.get(this.baseUrl + `/collections/` + id);
  }

  getMetaTags = async () => {
    return await cachios.get(this.baseUrl + `/seo-tags`);
  }

  postNewsletter = async(email) => {
    const url = this.baseUrl + `/news-letter`;
    return await axios.post(url, email);
  }

  postAskAnExpert = async(data) => {
    const url = this.baseUrl + `/expert-appointment`;
    return await axios.post(url, data);
  }

  postRequestSamples = async(data) => {
    const url = this.baseUrl + `/shipping-details`;
    return await axios.post(url, data);
  }
  
  getSocialMediaLinks = async () => {
    return await cachios.get(this.baseUrl + `/social-media`);
  }
 
}
export default new Api();


